const MAIN_DOMAINS = ['localhost', 'loanflow.com', 'www.loanflow.com'];

export function isMainSite(): boolean {
  const hostname = window.location.hostname;
  if (MAIN_DOMAINS.includes(hostname)) return true;
  if (hostname.endsWith('.onrender.com')) return true;
  return false;
}

export function isCustomDomain(): boolean {
  return !isMainSite();
}

export function getCurrentHostname(): string {
  return window.location.hostname;
}
